// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class AnonymousIdentity implements flatbuffers.IUnpackableObject<AnonymousIdentityT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AnonymousIdentity {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAnonymousIdentity(
    bb: flatbuffers.ByteBuffer,
    obj?: AnonymousIdentity,
  ): AnonymousIdentity {
    return (obj || new AnonymousIdentity()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsAnonymousIdentity(
    bb: flatbuffers.ByteBuffer,
    obj?: AnonymousIdentity,
  ): AnonymousIdentity {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AnonymousIdentity()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static startAnonymousIdentity(builder: flatbuffers.Builder) {
    builder.startObject(0);
  }

  static endAnonymousIdentity(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createAnonymousIdentity(builder: flatbuffers.Builder): flatbuffers.Offset {
    AnonymousIdentity.startAnonymousIdentity(builder);
    return AnonymousIdentity.endAnonymousIdentity(builder);
  }

  unpack(): AnonymousIdentityT {
    return new AnonymousIdentityT();
  }

  unpackTo(_o: AnonymousIdentityT): void {}

  unpackFields(...fields: string[]): AnonymousIdentityT {
    const t = new AnonymousIdentityT();
    const fieldSet = new Set(fields);
    return t;
  }
}

export class AnonymousIdentityT implements flatbuffers.IGeneratedObject {
  constructor() {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return AnonymousIdentity.createAnonymousIdentity(builder);
  }

  clone(): AnonymousIdentityT {
    const obj = new AnonymousIdentityT();
    return obj;
  }

  equals(other: AnonymousIdentityT): boolean {
    return true;
  }
}

export function verifyAnonymousIdentity(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
  } finally {
    verifier.popDepth();
  }
}
